import { jsx as _jsx } from "react/jsx-runtime";
import copyrightCheckerDossierWithPhotos from '../../../../organisms/table/__mock__/copyrightCheckerDossierWithPhotosMock.json';
import { CopyrightCheckerDossierView } from './CopyrightCheckerDossier.view';
export default {
    title: 'Pages/copyright-checker/dossiers/:dossierId',
    component: CopyrightCheckerDossierView,
    parameters: {
        padding: 0,
    },
};
const Template = args => (_jsx(CopyrightCheckerDossierView, { ...args }));
export const Primary = Template.bind({});
Primary.args = {
    dossier: copyrightCheckerDossierWithPhotos,
    data: {
        detections: [],
    },
};
